/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Options_Watermark_Last_UpdatedInputs */

const en_options_watermark_last_updated = /** @type {(inputs: Options_Watermark_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last updated: ${i?.date}`)
};

const fr_options_watermark_last_updated = /** @type {(inputs: Options_Watermark_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dernière mise à jour : ${i?.date}`)
};

const de_options_watermark_last_updated = /** @type {(inputs: Options_Watermark_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuletzt aktualisiert: ${i?.date}`)
};

const it_options_watermark_last_updated = /** @type {(inputs: Options_Watermark_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento: ${i?.date}`)
};

const ru_options_watermark_last_updated = /** @type {(inputs: Options_Watermark_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Последнее обновление: ${i?.date}`)
};

const es_options_watermark_last_updated = /** @type {(inputs: Options_Watermark_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Última actualización: ${i?.date}`)
};

const zh_cn2_options_watermark_last_updated = /** @type {(inputs: Options_Watermark_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`上次更新：${i?.date}`)
};

const ja_options_watermark_last_updated = /** @type {(inputs: Options_Watermark_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最終更新: ${i?.date}`)
};

const hi_options_watermark_last_updated = /** @type {(inputs: Options_Watermark_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अंतिम अपडेट: ${i?.date}`)
};

const pt_pt2_options_watermark_last_updated = /** @type {(inputs: Options_Watermark_Last_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Última atualização: ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Last updated: {date}" |
*
* @param {Options_Watermark_Last_UpdatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_last_updated = /** @type {((inputs: Options_Watermark_Last_UpdatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Last_UpdatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_watermark_last_updated(inputs)
	if (locale === "de") return de_options_watermark_last_updated(inputs)
	if (locale === "it") return it_options_watermark_last_updated(inputs)
	if (locale === "ru") return ru_options_watermark_last_updated(inputs)
	if (locale === "es") return es_options_watermark_last_updated(inputs)
	if (locale === "zh-CN") return zh_cn2_options_watermark_last_updated(inputs)
	if (locale === "ja") return ja_options_watermark_last_updated(inputs)
	if (locale === "hi") return hi_options_watermark_last_updated(inputs)
	if (locale === "pt-PT") return pt_pt2_options_watermark_last_updated(inputs)
	return en_options_watermark_last_updated(inputs)
});